import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { RouteLocationRaw } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterLink',
  props: {
    to: {},
    prevent: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link", true)!

  return (!_ctx.prevent)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: _ctx.to
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})